import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import '../ManagerPortal/ManagerPortal.css';
import { useDispatch, useSelector } from 'react-redux';
import { loginUserWithRedirect } from 'auth/authUtils';
import { authenticatingUser } from 'redux/actions/auth';

const NotAuth = () => {
    const admin = useSelector((state) => state.user.admin);
    const userAuthenticating = useSelector((state) => state.user.authenticatingUser);
    const authenticated = useSelector((state) => state.user.authenticated);
    const history = useHistory();
    const dispatch = useDispatch();

    const login = () => {
        dispatch(authenticatingUser());
        loginUserWithRedirect();
    };

    if (admin) {
        return (
            <div className='Main unauth'>
                <h3>You Are Not Authorized to View This Page</h3>
                <Link to='/'>
                    <Button onClick={() => history.push('/')}>Go Home</Button>
                </Link>
            </div>
        );
    } else {
        return (
            <div className='Main unauth'>
                <h3>You must login to view this page</h3>
                {userAuthenticating && <div>Logging in...</div>}
                {!userAuthenticating && !authenticated && <Button color='primary' variant='outlined' onClick={login}>Log In</Button>}
            </div>
        );
    }
};

export default NotAuth;
